<template>
    <div>
        <v-server-table ref="IncidentTypeTable" url="/admin/incident-types-list" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <router-link :to="`/incidents/settings/incident-types/builder`" class="btn btn-default"><i class="fa fa-plus-circle text-success"></i> Create New Incident Type</router-link>
            </div>

            <router-link slot="IncidentTypeId" slot-scope="props" :to="`/incidents/settings/incident-types/builder/${props.row.IncidentTypeId}`" title="Edit Incident Type" class="btn btn-sm btn-light">
                <i class="fa fa-edit text-info"></i> Edit
            </router-link>

            <template slot="IsActive" slot-scope="props">
                <label :class="`badge badge-${props.row.IsActive == 1 ? 'success' : 'warning'}`">
                    {{ props.row.IsActive == 1 ? 'Active' : 'Inactive' }}
                </label>
            </template>

            <template slot="published_at" slot-scope="props">
                {{ props.row.published_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
            </template>

            <template slot="child_row" slot-scope="props">
                <div class="mb-1">
                    <label class="text-muted">Require Jobsite:</label>
                    <span class="badge badge-success" v-if="props.row.inci_require_jobsite == 1">Yes</span>
                    <span class="badge badge-secondary" v-else>No</span>
                </div>
                <div class="mb-1">
                    <label class="text-muted">Require Incident Foreman:</label>
                    <span class="badge badge-success" v-if="props.row.inci_require_foreman == 1">Yes</span>
                    <span class="badge badge-secondary" v-else>No</span>
                </div>
                <div class="mb-1">
                    <label class="text-muted">Require Project Manager:</label>
                    <span class="badge badge-success" v-if="props.row.inci_require_pm == 1">Yes</span>
                    <span class="badge badge-secondary" v-else>No</span>
                </div>
                <div class="mb-1">
                    <label class="text-muted">Require Superintendent:</label>
                    <span class="badge badge-success" v-if="props.row.inci_require_superintendent == 1">Yes</span>
                    <span class="badge badge-secondary" v-else>No</span>
                </div>
                <div class="mb-1">
                    <label class="text-muted">Require Supervisor:</label>
                    <span class="badge badge-success" v-if="props.row.inci_require_supervisor == 1">Yes</span>
                    <span class="badge badge-secondary" v-else>No</span>
                </div>
                <div class="mb-1">
                    <label class="text-muted">Require Crew Size:</label>
                    <span class="badge badge-success" v-if="props.row.inci_require_crew_size == 1">Yes</span>
                    <span class="badge badge-secondary" v-else>No</span>
                </div>
                <div class="mb-1">
                    <label class="text-muted">Require Crew Members:</label>
                    <span class="badge badge-success" v-if="props.row.inci_require_crew_members == 1">Yes</span>
                    <span class="badge badge-secondary" v-else>No</span>
                </div>
                <div class="mb-1">
                    <label class="text-muted">Require Type of Work Performed:</label>
                    <span class="badge badge-success" v-if="props.row.inci_require_type_of_work == 1">Yes</span>
                    <span class="badge badge-secondary" v-else>No</span>
                </div>
                <div class="mb-1">
                    <label class="text-muted">Require Root Cause Analysis:</label>
                    <span class="badge badge-success" v-if="props.row.inci_require_root_cause == 1">Yes</span>
                    <span class="badge badge-secondary" v-else>No</span>
                </div>
                <div class="mb-1">
                    <label class="text-muted">Require Corrective Action(s):</label>
                    <span class="badge badge-success" v-if="props.row.inci_require_correct_action == 1">Yes</span>
                    <span class="badge badge-secondary" v-else>No</span>
                </div>
                <div class="mb-1">
                    <label class="text-muted">Show Reminder to Upload PTP if PTP was completed:</label>
                    <span class="badge badge-success" v-if="props.row.inci_ptp_reminder == 1">Yes</span>
                    <span class="badge badge-secondary" v-else>No</span>
                </div>
                <div class="mb-1">
                    <label class="text-muted">Enable Disciplinary Section:</label>
                    <span class="badge badge-success" v-if="props.row.inci_require_disc_actions == 1">Yes</span>
                    <span class="badge badge-secondary" v-else>No</span>
                </div>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                columns: [
                    'IncidentTypeId',
                    'TypeName',
                    'set_name',
                    'IsActive',
                    //'published_at'
                ],
                options: {
                    headings: {
                        IncidentTypeId: 'Edit',
                        TypeName: 'Incident Type Name',
                        set_name: 'Custom Fields Set',
                        IsActive: 'Status',
                        //published_at: 'Published',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'incidenttype.TypeName',
                    },
                    uniqueKey: 'IncidentTypeId',
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('inciTypeListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                },
            }
        }
    }
</script>
